// The titles of the users at Inlook, as in UserTitles of the backend. ProBuilder chooses
// the people in charge of a project by them.
const USER_TITLES = [
  'foreman',
  'project-manager',
  'installation-manager',
  'area-manager',
  'area-director',
];

export default USER_TITLES;
